export default {
  leaveMerchantView: {
    id: 'header_bo_leave_merchant_view',
    defaultMessage: 'Leave merchant view',
  },
}
